import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';

export type BuilderV2Action = 'Publish' | 'Create';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action: BuilderV2Action;
}

function ConfirmationModal({ isOpen, onClose, action, onConfirm }: Props) {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalHeader className="w-full justify-between items-center">
        <Typography variant="subtitleLarge" fontWeight="semibold">
          <T kind={`${action} this collection?`} />
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Typography variant="bodyMedium">
          {action === 'Publish' ? (
            <T kind="Publishing the collection will finalize your changes and make the collection available to participants. Are you sure you want to continue?" />
          ) : (
            <T kind="Creating the collection will save your work as a draft. Are you sure you want to continue?" />
          )}
        </Typography>
      </ModalBody>
      <ModalFooter className="flex-row justify-end">
        <Button
          variant="text"
          color="secondary"
          onClick={onClose}
          data-intercom-target="builder-v2-modal-cancel-button"
        >
          <T kind="Cancel" />
        </Button>
        <Button
          onClick={onConfirm}
          data-intercom-target={`builder-v2-modal-${action.toLowerCase()}-collection-button`}
        >
          <T kind={`${action} Collection`} />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default observer(ConfirmationModal);
